import React from 'react';
import { CircularProgress } from '@mui/material';
import { DatePicker as MUIDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment-timezone';

import { ProtectedRouteContext } from '../../Context';

const DatePicker = ({
    value,
    disabled,
    onChange,
    onBlur,
    size,
    width,
    saving,
    slotProps,
    error,
    clearable = false,
    inputProps,
    textFieldSx,
    ...restOfProps
}) => {
    const defaultSlotProps = {
        textField: {
            disabled: disabled || saving,
            size: !!size ? size : undefined,
            error: error || false,
            onBlur,
            sx: {
                width: !!width ? width : '13rem',
                '.Mui-disabled': {
                    color: (theme) => theme.palette.primary.main,
                    WebkitTextFillColor: 'unset',
                    fontWeight: 700,
                },
                ...textFieldSx,
            },
            inputProps: inputProps || null,
        },
        openPickerButton: {
            color: error ? 'error' : 'primary',
            ...slotProps?.openPickerButton,
        },
        field: {
            clearable,
        },
    };

    const { userSettings } = React.useContext(ProtectedRouteContext);

    moment.tz.setDefault(userSettings?.ClientTimeZone || 'America/Chicago');

    const Saving = () => {
        return <CircularProgress size={20} />;
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
            dateLibInstance={moment}
        >
            <MUIDatePicker
                value={!!value ? value : null}
                onChange={(newVal) => onChange?.(newVal)}
                onAccept={(newVal) => onBlur?.(newVal)}
                disabled={disabled || saving}
                slotProps={{
                    ...defaultSlotProps,
                    ...slotProps,
                }}
                slots={{
                    openPickerButton: saving ? Saving : undefined,
                }}
                {...restOfProps}
            />
        </LocalizationProvider>
    );
};

export default DatePicker;
